import { render } from "./bulkUsers.vue?vue&type=template&id=8e910bf2&scoped=true"
import script from "./bulkUsers.vue?vue&type=script&lang=js"
export * from "./bulkUsers.vue?vue&type=script&lang=js"

import "./bulkUsers.vue?vue&type=style&index=0&id=8e910bf2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e910bf2"]])

export default __exports__